"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.useTokenList = void 0;
var react_1 = require("react");
var useEthers_1 = require("./useEthers");
function useTokenList(tokenListURI, overrideChainId, tags) {
    var _this = this;
    var providerChainId = useEthers_1.useEthers().chainId;
    var _a = react_1.useState(), tokenList = _a[0], setTokenList = _a[1];
    var chainId = overrideChainId || providerChainId;
    react_1.useEffect(function () {
        fetch(tokenListURI)
            .then(function (response) { return __awaiter(_this, void 0, void 0, function () {
            var _a, name_1, logoURI, tokens, errorMessage;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!response.ok) return [3 /*break*/, 2];
                        return [4 /*yield*/, response.json()];
                    case 1:
                        _a = _b.sent(), name_1 = _a.name, logoURI = _a.logoURI, tokens = _a.tokens;
                        setTokenList({
                            name: name_1,
                            logoURI: logoURI,
                            tokens: tokens.filter(function (token) {
                                var sameChainId = token.chainId === chainId;
                                if (!tags) {
                                    return sameChainId;
                                }
                                return sameChainId && token.tags && token.tags.some(function (tag) { return tags.includes(tag); });
                            })
                        });
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, response.text()];
                    case 3:
                        errorMessage = _b.sent();
                        return [2 /*return*/, Promise.reject(new Error(errorMessage))];
                    case 4: return [2 /*return*/];
                }
            });
        }); })["catch"](function (err) {
            console.log(err);
            setTokenList(undefined);
        });
    }, [tokenListURI, chainId]);
    return tokenList;
}
exports.useTokenList = useTokenList;
//# sourceMappingURL=useTokenList.js.map